var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1644_30262)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.6V7.46667H0V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 0V1.06667H22.4V0H9.6ZM9.6 2.13333V3.2H22.4V2.13333H9.6ZM9.6 4.26667V5.33333H22.4V4.26667H9.6ZM9.6 6.4V7.46667H22.4V6.4H9.6ZM0 8.53333V9.6H22.4V8.53333H0ZM0 10.6667V11.7333H22.4V10.6667H0ZM0 12.8V13.8667H22.4V12.8H0ZM0 14.9333V16H22.4V14.9333H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06689 1.06641V2.13307H2.13356V1.06641H1.06689ZM3.20023 1.06641V2.13307H4.26689V1.06641H3.20023ZM5.33356 1.06641V2.13307H6.40023V1.06641H5.33356ZM7.4669 1.06641V2.13307H8.53356V1.06641H7.4669ZM6.40023 2.13307V3.19974H7.4669V2.13307H6.40023ZM4.26689 2.13307V3.19974H5.33356V2.13307H4.26689ZM2.13356 2.13307V3.19974H3.20023V2.13307H2.13356ZM1.06689 3.19974V4.26641H2.13356V3.19974H1.06689ZM3.20023 3.19974V4.26641H4.26689V3.19974H3.20023ZM5.33356 3.19974V4.26641H6.40023V3.19974H5.33356ZM7.4669 3.19974V4.26641H8.53356V3.19974H7.4669ZM1.06689 5.33307V6.39974H2.13356V5.33307H1.06689ZM3.20023 5.33307V6.39974H4.26689V5.33307H3.20023ZM5.33356 5.33307V6.39974H6.40023V5.33307H5.33356ZM7.4669 5.33307V6.39974H8.53356V5.33307H7.4669ZM6.40023 4.26641V5.33307H7.4669V4.26641H6.40023ZM4.26689 4.26641V5.33307H5.33356V4.26641H4.26689ZM2.13356 4.26641V5.33307H3.20023V4.26641H2.13356Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1644_30262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa-flag.b7c0b6f62b7ce66566a654dc6a8b0b04.svg";
export { ForwardRef as ReactComponent };